module.exports = __webpack_public_path__ + "img/cave156.c977af8d.jpg";